export enum ErrorType {
  CACHE_NOT_FOUND = 'Cache not found',
}

export enum ContentStatus {
  Ready = 'Ready',
  Live = 'Live',
}

export enum PatchStatus {
  Staged = 'Staged',
  Deployed = 'Deployed',
}

export enum SettingType {
  Greenbox = 'Greenbox',
  Benefits = 'Benefits',
  Disclaimers = 'Disclaimers',
}

export enum MembershipLevel {
  CLASSIC = 'CLASSIC',
  PLUS = 'PLUS',
  PREMIER = 'PREMIER',
}

export enum ClubCode {
  AL = '001',
  CA = '004',
  EC = '215',
  HI = '018',
  ACMO = '065',
  NM = '601',
  NNE = '036',
  TW = '258',
  TX = '252',
}

export enum Ability {
  canViewMembership = 0,
  canChangeMembership = 1,
  canMakePayment = 2,
  canUpdatePhone = 3,
  canUpdateEmail = 4,
}

// enum for membership benefit levels
// notes: ranking is based on index from lowest level (classic) to highest level (premier-rv)

export enum MembershipBenefitLevels {
  Classic = 'classic',
  ClassicRv = 'classic-rv',
  Plus = 'plus',
  PlusRv = 'plus-rv',
  Premier = 'premier',
  PremierRv = 'premier-rv',
}

export enum RoleType {
  Primary = 'PR',
  AdultAssociate = 'AD',
  Dependent = 'DE',
  Associate = 'AS',
}

export enum MembershipTitles {
  CLASSIC = 'Classic',
  PLUS = 'Plus',
  PREMIER = 'Premier',
}

export enum AppName {
  MSS = 'mss',
}
